export default __webpack_public_path__ + "static/media/llpic.7ad04051.png";